module.exports = __webpack_public_path__ + "img/guileme_avator-1.f7b55704.png";